 import React, { useState } from "react";
 import { Table, Button } from "react-bootstrap";
 
 const reportUrls = {
   OCCUD: "https://app.powerbi.com/view?r=eyJrIjoiNDZiMGI0MDQtYWEyZi00NzM3LWFiNDYtNDFmYTJkNjg2MDllIiwidCI6IjBlNTI1YjNlLTc2NTgtNGI2Zi1hYmJkLTU5N2E4M2UwYzMxNiIsImMiOjl9",
   
 };

const Shared = () => {
    const [activeReportKey, setActiveReportKey] = useState(null);
  const links = [
    { name: "Ocean Carrier Contract Utilization Dashboard", key: "OCCUD", internal: true  },
    { name: "Invoice(Billing) Dashboard", url: "https://example.com/inventory-report" },
    { name: "Provision Analysis", url: "https://example.com/finance-report" },
    { name: "Carrier Performance - Lead Time Analysis", url: "https://example.com/finance-report" },
  ];
    const handleClick = (link) => {
     if (link.internal && link.key in reportUrls) {
       setActiveReportKey(link.key);
     } else if (link.url) {
       window.open(link.url, "_blank", "noopener,noreferrer");
     }
   };
 
   const handleBack = () => setActiveReportKey(null);
 
   if (activeReportKey && reportUrls[activeReportKey]) {
     return (
       <div style={{ margin: "10px" }}>
         <Button
           variant="secondary"
           onClick={handleBack}
           style={{ marginBottom: "15px" }}
         >
           &lt; Back to Reports
         </Button>
         <div style={{ width: "100%", height: "100vh" }}>
           <iframe
             title="Power BI Report"
             width="100%"
             height="100%"
             src={reportUrls[activeReportKey]}
             allowFullScreen
             style={{ border: "none" }}
           ></iframe>
         </div>
       </div>
     );
   }
 
   return (
     <div style={{ margin: "10px" }}>
       <h5 className="mb-3">Factory Reports</h5>
       <Table bordered size="sm" className="text-center align-middle">
         <thead className="table-light">
           <tr>
             <th style={{ width: "5%" }}>#</th>
             <th style={{ textAlign: "left" }}>Report Name</th>
             <th style={{ width: "10%" }}>Action</th>
           </tr>
         </thead>
         <tbody>
           {links.map((link, index) => (
             <tr key={index}>
               <td>{index + 1}</td>
               <td style={{ textAlign: "left" }}>{link.name}</td>
               <td>
                 <Button
                   variant="outline-primary"
                   size="sm"
                   onClick={() => handleClick(link)}
                 >
                   View
                 </Button>
               </td>
             </tr>
           ))}
         </tbody>
       </Table>
     </div>
   );
 };
 

 
export default Shared;
